export default "__VITE_ASSET__CwSZcz2Z__"